import React, { forwardRef, useId } from "react";

const FormInput = forwardRef(
  ({ className = "", multiline = false, title, id, ...props }, ref) => {
    const Component = multiline ? "textarea" : "input";
    const generatedId = useId();
    const inputId = id || `form-input-${generatedId.replace(/:/g, "")}`;

    return (
      <div className={`column gap-s`.trim()}>
        {title && (
          <label
            htmlFor={inputId}
            className="content-semibold text-primary-1"
          >
            {title}
          </label>
        )}
        <Component
          ref={ref}
          id={inputId}
          className={`form-input width-100 body1 text-primary-1 ${className}`.trim()}
          // placeholder={title}
          {...props}
        />
      </div>
    );
  },
);

FormInput.displayName = "FormInput";

export default FormInput;
